import type { SavedSearchesQuery } from '@/redux/modules/savedSearch';
import type { SavedSearch } from '@/redux/modules/search/save/saveSearch.types';

import { TypedActionWithPayload } from '@/types/redux';

export const DELETE_SAVED_SEARCH_FAIL = 'DELETE_SAVED_SEARCH_FAIL';
export const DELETE_SAVED_SEARCH_REQUEST = 'DELETE_SAVED_SEARCH_REQUEST';
export const DELETE_SAVED_SEARCH_SUCCESS = 'DELETE_SAVED_SEARCH_SUCCESS';
export type DeleteSavedSearchSuccessAction = TypedActionWithPayload<
    typeof DELETE_SAVED_SEARCH_SUCCESS,
    unknown,
    {
        actionTime: number;
        /**
         * A string when it comes from the email unfollow link's query string.
         */
        savedSearchId: number | string;
    }
>;

export const LOAD_SAVED_SEARCHES_FAIL = 'LOAD_SAVED_SEARCHES_FAIL';
export const LOAD_SAVED_SEARCHES_REQUEST = 'LOAD_SAVED_SEARCHES_REQUEST';
export const LOAD_SAVED_SEARCHES_SUCCESS = 'LOAD_SAVED_SEARCHES_SUCCESS';

/**
 * Identifies one searches request, so its response or failure can be told apart from those of
 * any other request, including one sent with the same params.
 */
export type LoadSavedSearchesMeta = {
    requestId: string;
};

export type LoadSavedSearchesRequestAction = TypedActionWithPayload<
    typeof LOAD_SAVED_SEARCHES_REQUEST,
    SavedSearchesQuery,
    LoadSavedSearchesMeta
>;

export type LoadSavedSearchesFailAction = TypedActionWithPayload<
    typeof LOAD_SAVED_SEARCHES_FAIL,
    unknown,
    LoadSavedSearchesMeta
>;

export type LoadSavedSearchesSuccessAction = TypedActionWithPayload<
    typeof LOAD_SAVED_SEARCHES_SUCCESS,
    SavedSearch[],
    LoadSavedSearchesMeta & {
        actionTime: number;
        page: number;
        pageSize: number;
        /**
         * When the request was sent; `actionTime` is when the response arrived.
         */
        requestedAt: number;
        totalRecords: number;
    }
>;

export const SUBSCRIBE_SAVED_SEARCH_FAIL = 'SUBSCRIBE_SAVED_SEARCH_FAIL';
export const SUBSCRIBE_SAVED_SEARCH_REQUEST = 'SUBSCRIBE_SAVED_SEARCH_REQUEST';
export const SUBSCRIBE_SAVED_SEARCH_SUCCESS = 'SUBSCRIBE_SAVED_SEARCH_SUCCESS';

export const UNSUBSCRIBE_SAVED_SEARCH_FAIL = 'UNSUBSCRIBE_SAVED_SEARCH_FAIL';
export const UNSUBSCRIBE_SAVED_SEARCH_REQUEST = 'UNSUBSCRIBE_SAVED_SEARCH_REQUEST';
export const UNSUBSCRIBE_SAVED_SEARCH_SUCCESS = 'UNSUBSCRIBE_SAVED_SEARCH_SUCCESS';

export const SUBSCRIBE_ALL_SAVED_SEARCH_FAIL = 'SUBSCRIBE_ALL_SAVED_SEARCH_FAIL';
export const SUBSCRIBE_ALL_SAVED_SEARCH_REQUEST = 'SUBSCRIBE_ALL_SAVED_SEARCH_REQUEST';
export const SUBSCRIBE_ALL_SAVED_SEARCH_SUCCESS = 'SUBSCRIBE_ALL_SAVED_SEARCH_SUCCESS';

export const UNSUBSCRIBE_ALL_SAVED_SEARCH_FAIL = 'UNSUBSCRIBE_ALL_SAVED_SEARCH_FAIL';
export const UNSUBSCRIBE_ALL_SAVED_SEARCH_REQUEST = 'UNSUBSCRIBE_ALL_SAVED_SEARCH_REQUEST';
export const UNSUBSCRIBE_ALL_SAVED_SEARCH_SUCCESS = 'UNSUBSCRIBE_ALL_SAVED_SEARCH_SUCCESS';

export const LOAD_SAVED_SEARCH_ITEMS_FAIL = 'LOAD_SAVED_SEARCH_ITEMS_FAIL';
export type LoadSavedSearchItemsFailAction = TypedActionWithPayload<typeof LOAD_SAVED_SEARCH_ITEMS_FAIL, unknown>;
export const LOAD_SAVED_SEARCH_ITEMS_REQUEST = 'LOAD_SAVED_SEARCH_ITEMS_REQUEST';
export const LOAD_SAVED_SEARCH_ITEMS_SUCCESS = 'LOAD_SAVED_SEARCH_ITEMS_SUCCESS';

export const SAVED_SEARCHES_TAB_QUERY_REMEMBER = 'SAVED_SEARCHES_TAB_QUERY_REMEMBER';

export const SAVED_SEARCH_ITEMS_FILTER_CHANGE = 'SAVED_SEARCH_ITEMS_FILTER_CHANGE';
